/**
 * Pattern that matches only characters allowed in ARS/hierarchy names: letters, digits,
 * underscores, and hyphens. Used both to validate names (see `checkName`) and to strip disallowed
 * characters from names before they are committed to state (see `stripDisallowedNameCharacters`).
 */
export const allowedNameCharactersPattern = /^[A-Za-z0-9_-]*$/;

/**
 * Removes any characters that are not alphanumeric, underscore, space or hyphen from a name value.
 *
 * @param value - The raw name value to strip disallowed characters from.
 * @returns The value containing only characters permitted by `allowedNameCharactersPattern`.
 */
export const stripDisallowedNameCharacters = (value: string): string =>
  value.replace(/[^A-Za-z0-9_-]/g, "");
